import * as Yup from "yup";

import { AkaStudentCoverage } from "Store/interfaces/products/coverage";

export const validationSchema = Yup.object().shape({
  coverage: Yup.mixed<AkaStudentCoverage>()
    .required()
    .oneOf(Object.values(AkaStudentCoverage)),
});
